import React from 'react';
import ReactDOM from 'react-dom';
import CallProcessor from '../../call_rescoring/CallProcessor';

class RescoreModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const callId = this.getAttribute('call-id');

    if (callId) {
      this.innerHTML = `
        <div class="modal fade" id="rescoreModal${callId}" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="myModalLabel">Rescore Call</h4>
              </div>
              <div class="modal-body" id="rescore-modal-body-${callId}">
              </div>
            </div>
          </div>
        </div>
      `;

      ReactDOM.render(
        React.createElement(CallProcessor, { callId }),
        this.querySelector(`#rescore-modal-body-${CSS.escape(callId)}`)
      );
    }
  }
}

customElements.define('rescore-modal', RescoreModal);
